import { inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { environment } from 'src/environments/environment';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectPurchaseOrderQuery = () => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: () => {
      if (environment.usePlayground) {
        return import('./purchase-order-list-query.mock').then(
          (m) => m.purchaseOrderListQueryMock.fullList
        );
      }

      return gqlToPromise(() => gqlService.listPO$());
    },
    queryKey: ['trials', 'detail', mainQuery.trialKey(), 'list-purchase-orders'],
  }));
};
